import { useBusiness } from '@/contexts/BusinessContext'

import { StatsCards } from '@/components/atoms'

import { CustomerModel } from '@/types'

interface CustomerStatsCardsProps {
  customer: CustomerModel.Customer
}

export const CustomerStatsCards = ({ customer }: CustomerStatsCardsProps) => {
  const { formatCurrency } = useBusiness()
  const { total_orders: totalOrders = 0, total_spent: totalSpent = 0 } = customer
  const averageOrderValue = totalOrders > 0 ? totalSpent / totalOrders : 0

  return (
    <StatsCards
      stats={[
        { title: 'Orders', value: totalOrders },
        { title: 'Amount spent', value: formatCurrency(totalSpent) },
        { title: 'Average order', value: formatCurrency(averageOrderValue) },
      ]}
    />
  )
}
